import { Button, TextField, Typography, Box } from "@mui/material";
import { ReportProblem, Send, Close, Warning } from "@mui/icons-material";
import { ReportExplanationProps } from "../../Utils/Types";
import { Vocabulary } from "../../Utils/Vocabulary";
import { useState } from "react";
import GenericModal from "../GenericModal";
import { endpoints } from "../../Utils/UrlEnum";
import { postData } from "../../Services/postData";

export default function ReportExplanation(props: ReportExplanationProps) {
  const { question } = props;
  const [open, setOpen] = useState(false);
  const [comments, setComments] = useState("");
  const clientId = localStorage.getItem("clientId");

  const submitReport = () => {
    const url = endpoints.examQuestionsReports;
    const body = {
      comments,
      questionId: question?._id,
      clientId,
      isCorrect: question?.progress?.isCorrect,
      selectedAnswers: question?.progress?.selectedAnswers,
    };

    postData(url, body).then((response) => {
      setOpen(false);
      setComments("");
    });
  };

  return (
    <Box>
      <Button
        startIcon={<ReportProblem />}
        onClick={() => setOpen(true)}
        variant="outlined"
        color="error"
        sx={{
          borderRadius: '20px',
          textTransform: 'none',
          fontWeight: 500,
          '&:hover': {
            transform: 'translateY(-1px)',
            boxShadow: (theme) => `0 4px 12px ${theme.palette.error.main}25`
          },
          transition: 'all 0.3s ease'
        }}
      >
        {Vocabulary.reportExplanation}
      </Button>
      
      <GenericModal
        open={open}
        onClose={() => setOpen(false)}
        title=""
        actions={
          <>
            <Button
              variant="outlined"
              onClick={() => setOpen(false)}
              startIcon={<Close />}
              color="error"
            >
              {Vocabulary.cancel}
            </Button>
            
            <Button
              variant="contained"
              onClick={submitReport}
              startIcon={<Send />}
              color="primary"
              disabled={!comments.trim()}
            >
              {Vocabulary.reportExplanation}
            </Button>
          </>
        }
      >
        <Box sx={{ textAlign: 'center', py: 2 }}>
          <Box sx={{ mb: 3 }}>
            <Warning 
              sx={{
                fontSize: 64,
                color: 'error.main',
                background: 'linear-gradient(135deg, rgba(244, 67, 54, 0.1) 0%, rgba(244, 67, 54, 0.2) 100%)',
                borderRadius: '50%',
                padding: 2,
                boxShadow: (theme) => `0 4px 20px ${theme.palette.error.main}30`
              }}
            />
          </Box>
          
          <Typography 
            variant="h5" 
            sx={{
              fontWeight: 600,
              color: 'error.main',
              mb: 2,
              fontSize: '1.5rem'
            }}
          >
            {Vocabulary.reportTitle}
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              color: 'text.secondary',
              lineHeight: 1.6,
              fontSize: '1rem',
              mb: 3
            }}
          >
            {Vocabulary.reportConfirmation}
          </Typography>

          <TextField
            multiline
            fullWidth
            rows={4}
            label={Vocabulary.description}
            placeholder={Vocabulary.reportDescriptionPlaceholder}
            value={comments}
            onChange={(e) => setComments(e.target.value)}
            variant="outlined"
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: '12px',
                '&:hover fieldset': {
                  borderColor: 'error.main',
                },
                '&.Mui-focused fieldset': {
                  borderColor: 'error.main',
                }
              },
              '& .MuiInputLabel-root': {
                '&.Mui-focused': {
                  color: 'error.main',
                }
              }
            }}
          />
        </Box>
      </GenericModal>
    </Box>
  );
}
